'use strict';

exports.__esModule = true;
exports['default'] = renderFieldset;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function getClassName(locals) {
  var _classnames;

  var len = locals.path.length;
  return _classnames3['default']((_classnames = {
    ui: true,
    form: true,
    segment: locals.path.length > 0,
    error: locals.hasError,
    'fieldset': true
  }, _classnames['fieldset-depth-' + len] = true, _classnames['fieldset-' + locals.path.join('-')] = len > 0, _classnames[locals.className] = !!locals.className, _classnames));
}

function renderFieldset(children, locals) {
  var legend = locals.label ? _react2['default'].createElement(
    'legend',
    { className: 'ui dividing header' },
    locals.label
  ) : null;
  var props = {
    className: getClassName(locals),
    disabled: locals.disabled
  };
  return _react2['default'].createElement.apply(null, ['fieldset', props, legend].concat(children));
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/tcomb-form-templates-semantic/lib/renderFieldset.js
// module id = 317
// module chunks = 0